import React from 'react'

import { B4, Icon, XStack, colors } from '@zet/design-system'
import { i18n } from '@zet/localization'

export const getApprovalRateState = ({
  approvalRate,
  approvalRateText,
}: {
  approvalRate?: 'HIGH' | 'MEDIUM' | 'LOW'
  approvalRateText?: string
}) => {
  switch (approvalRate) {
    case 'HIGH':
      return {
        icon: 'DoneOutlined',
        textStyle: 'text-success-100',
        iconColor: colors.success[100],
        text: i18n.t('recommendationCard.approvalChance', {
          initialText: approvalRateText || 'High',
        }),
      }
    case 'MEDIUM':
      return {
        icon: 'DoneOutlined',
        textStyle: 'text-warning-150',
        iconColor: colors.warning[150],
        text: i18n.t('recommendationCard.approvalChance', {
          initialText: approvalRateText || 'Medium',
        }),
      }
    case 'LOW':
      return {
        icon: 'ErrorOutlined',
        textStyle: 'text-error-150',
        iconColor: colors.error[150],
        text: i18n.t('recommendationCard.approvalChance', {
          initialText: approvalRateText || 'Low',
        }),
      }
    default:
      return {
        icon: 'ErrorOutlined',
        textStyle: 'text-error-150',
        iconColor: colors.error[150],
        text: i18n.t('recommendationCard.notEligible'),
      }
  }
}

type BrandCardEligiblityProps = {
  approvalRate?: {
    approvalRateTextColor?: 'HIGH' | 'MEDIUM'
    approvalRateText?: string
    highApproval?: boolean
  }
}

const BrandCardEligiblity = ({ approvalRate }: BrandCardEligiblityProps) => {
  const approvalRateState = getApprovalRateState({
    approvalRate: approvalRate?.approvalRateTextColor,
    approvalRateText: approvalRate?.approvalRateText,
  })

  if (!approvalRate) {
    return <></>
  }

  return (
    <XStack className="mt-4/2 items-center space-x-1">
      <Icon
        type={approvalRateState?.icon}
        color={approvalRateState?.iconColor}
        size={16}
      />
      <B4 className={approvalRateState.textStyle}>{approvalRateState?.text}</B4>
    </XStack>
  )
}

export default BrandCardEligiblity
